import { User } from "@firebase/auth";
import { patientApi } from "@mgdx/api/lib/patientApi";
import { PatientUpdateStatusEnum } from "@mgdx/shared/src/models/Patient";
import { apiErrorHandler, errorHandlerReport, firebaseErrorHandler, isFirebaseError } from "@mgdx-libs/error-handler";
import { getFirebaseAuth, setAccessToken } from "@mgdx-libs/firebase";

import { setCurrentUser } from "../../stores/currentUserStore";

export const updatePatientToEmailVerifiedAndSetToStore = async (firebaseUser: User) => {
  // メール確認前に発行されたトークンは email_verified が false のままなので、取り直してから更新する
  const accessToken = await firebaseUser.getIdToken(true).catch(async (error) => {
    if (isFirebaseError(error)) {
      try {
        firebaseErrorHandler(error);
      } catch (e) {
        await errorHandlerReport(e as Error);
      }
    } else {
      await errorHandlerReport(error);
    }
    throw error;
  });

  // 取り直し中に別ユーザーへ切り替わった場合は、古いユーザーのトークンを保存せず更新も送らない
  if (getFirebaseAuth().currentUser?.uid !== firebaseUser.uid) return;
  setAccessToken(accessToken);

  await patientApi
    .putPatientStatus({
      putPatientStatusRequestBody: {
        status: PatientUpdateStatusEnum.Verified,
      },
    })
    .then((patient) => {
      // 更新中に別ユーザーへ切り替わった場合は、古いユーザーの患者情報を書き込まない
      if (getFirebaseAuth().currentUser?.uid !== firebaseUser.uid) return;
      setCurrentUser(patient);
    })
    .catch(async (errorOrResponse) => {
      if (errorOrResponse instanceof Response) {
        const apiError = await apiErrorHandler(errorOrResponse);
        errorHandlerReport(apiError);
        throw apiError;
      } else {
        await errorHandlerReport(errorOrResponse);
        throw errorOrResponse;
      }
    });
};
